import { render } from "./GettingStarted.vue?vue&type=template&id=54c9f73c&scoped=true&ts=true"
import script from "./GettingStarted.vue?vue&type=script&lang=ts"
export * from "./GettingStarted.vue?vue&type=script&lang=ts"

import "./GettingStarted.vue?vue&type=style&index=0&id=54c9f73c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c9f73c"]])

export default __exports__